import { useMemo } from 'react'
import { useSearchParams } from 'react-router'
import { CardContent, CardFooter } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from '@/components/ui/table'

export function UsersTableSkeleton() {
  const [searchParams] = useSearchParams()
  const ROWS = useMemo(
    () => Number(searchParams.get('limit') ?? '10'),
    [searchParams]
  )

  return (
    <>
      <CardContent>
        <div className="rounded-md border">
          <Table>
            <TableHeader>
              <TableRow className="bg-muted/50 hover:bg-muted/50">
                <TableHead>
                  <Skeleton className="h-6 w-20 rounded" />
                </TableHead>
                <TableHead />
                <TableHead />
                <TableHead />
              </TableRow>
            </TableHeader>
            <TableBody>
              {Array.from({ length: ROWS }).map((_, i) => (
                <TableRow key={i}>
                  <TableCell style={{ width: 360 }}>
                    <div className="px-2 py-1 flex items-center gap-2">
                      <Skeleton className="size-4 rounded-full" />
                      <Skeleton className="h-5 w-56 rounded" />
                    </div>
                  </TableCell>
                  <TableCell className="hidden md:table-cell">
                    <div className="px-2 py-1 flex items-center gap-2">
                      <Skeleton className="size-4.5 rounded-full" />
                      <Skeleton className="h-4 w-24 rounded" />
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="px-2 py-1 flex items-center justify-end gap-2">
                      <Skeleton className="h-4 w-24 rounded" />
                      <Skeleton className="h-2.5 w-[60px] rounded-full" />
                    </div>
                  </TableCell>
                  <TableCell style={{ maxWidth: 160 }}>
                    <div className="px-2 py-1 flex items-center justify-end gap-2">
                      <Skeleton className="h-4 w-32 rounded" />
                      <Skeleton className="size-4 rounded-full" />
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
      <CardFooter className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-20 rounded" />
          <Skeleton className="h-8 w-20 rounded-md" />
        </div>
        <div className="flex items-center justify-center">
          <Skeleton className="h-4 w-20 rounded" />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="size-8 rounded-md" />
          <Skeleton className="size-8 rounded-md" />
          <Skeleton className="size-8 rounded-md" />
          <Skeleton className="size-8 rounded-md" />
        </div>
      </CardFooter>
    </>
  )
}
